import { render } from "./MenuW.vue?vue&type=template&id=7dad8a98&scoped=true"
import script from "./MenuW.vue?vue&type=script&lang=js"
export * from "./MenuW.vue?vue&type=script&lang=js"

import "./MenuW.vue?vue&type=style&index=0&id=7dad8a98&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dad8a98"]])

export default __exports__